import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Strip from "../customComponent/Strip/Strip";
import ExternalLayout from "../customComponent/ExternalLayout/ExternalLayout";
import RenderPage from "../customComponent/RenderPage/RenderPage";
import SEOComponent from "../customComponent/SEO/SEOComponent";
import CustomPagination from "./Home/CustomPagination";
import getTestData from "../../api/services/TestService";
import getPatients from "../../api/services/getPatients";
import application_contants from "../constants/application_contant";
import Testsdata from "../Utils/Json/TestData";
import VisitService from "../../api/services/VisitService";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";


const TestData = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const perPage = 10; // Change this to the number of cards per page
  // const totalCards = data.length; // Assuming 'data' is the array of cards
  // const totalPages = Math.ceil(totalCards / perPage);
  const history = useHistory();

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const openPdfInNewTab = (pdfPath) => {
    // Use window.open to open the PDF in a new tab
    const fullUrl = `https://drive.google.com/file/d/1FTZv5gUZ-kvIBfzj9L8hA8WKS6UV0Ewk/view?usp=sharing`;
    window.open(fullUrl, "_blank");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `http://15.207.223.68:5000/getVisit?page=${currentPage}&pageSize=${perPage}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Fetch Result:", result);

        if (result && result.patients && Array.isArray(result.patients.rows)) {
          setData(result.patients.rows);
          setTotalPages(result.totalPages || 1);
        } else {
          console.error("Invalid response format:", result);
        }
      } catch (error) {
        console.error("Error fetching patient data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentPage]);

  useEffect(() => {
    console.log("Data Length:", data.length); // Add this log
  }, [data]);

  console.log("Data:", data);
  console.log("Current Page:", currentPage);
  console.log("Total Pages:", totalPages);

  const viewDetails = (patientData) => {
    // Navigate to VisitDetails and pass data as state
    history.push({
      pathname: "/visitdetails",
      state: { patientData },
    });
  };

  return (
    <ExternalLayout>
      <RenderPage
        id="tst-landing"
        className={`render px-0 render-page`}
        containerType="container-fluid"
      >
        <Strip
          id="tst-strip-Video"
          className="strip strip-no-padding "
          containerType="container-fluid mb-5 mt-5"
        >
          <SEOComponent
            title="Test"
            keywords="Test"
            description="Antlia"
            siteUrl="/Antlia"
          />
          <Row className="mx-0 background-container container mx-5">
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={11}
              className="m-auto  pt-4 "
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="pt-3 pl-5 "
                >
                  <p className="p-small title-bold2 align-left">
                    <span className="p-small section-title title-bold1">
                      Visits
                    </span>
                  </p>
                  <p className="pt-3">
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      resultsPerPage={perPage}
                      totalPatients={data.length}
                    />
                  </p>

                  <table className="custom-table section-title p-5">
                    <thead>
                      <tr className="pl-5">
                        <th className="p-lesserthan-small" style={{ width: "20%" }}>Name</th>
                        <th className="p-lesserthan-small">Visit ID</th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "20%" }}
                        >
                          Patient ID
                        </th>
                        <th className="p-lesserthan-small">Date</th>

                        <th
                          className="p-lesserthan-small"
                          style={{ width: "10%" }}
                        >
                          Report
                        </th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "10%" }}
                        >
                          View Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item.visitid}>
                            <td className="p-lesserthan-small">{item.firstname}</td>
                            <td className="p-lesserthan-small ">
                              {item.visitid}
                            </td>
                            <td className="p-lesserthan-small ">
                              {item.patientid}
                            </td>
                            <td className="p-lesserthan-small ">{item.date}</td>

                            <td className="card-icon1 ">
                              {" "}
                              <img
                                src={application_contants.report}
                                alt="Icon 2"
                                onClick={() => openPdfInNewTab(item.pdfPath)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                            <td className="p-lesserthan-small cursor-pointer custom-reference-links"><span onClick={() => viewDetails(item)}>View</span></td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5">Coming soon ....</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Col>
          </Row>
        </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

export default TestData;
